const reducerName = 'knowledge';
const addAction = (name = '') => {
  let result = '';

  result = `${reducerName}_${name}`;

  return result;
};

/**
 * @description 知识库
 * @namespace messageTypes
 * @property {string} reducer - 对应的reducer名字
 * @property {string} info - 账户信息
 * @property {string} list - 文章列表
 * @property {string} search - 搜索值
 * @property {string} catalogList - 目录列表
 */
const knowledgeTypes = {
  reducer: reducerName,
  info: addAction('info'),
  list: addAction('list'),
  search: addAction('search'),
  catalogId: addAction('catalogId'),
  catalogList: addAction('catalogList'),
};

const actions = {
  knowledgeTypes,
};

export default actions;
